module.exports = __webpack_public_path__ + "img/willing-risk-taker.c7b0149c.svg";